import { useTranslations } from 'next-intl'

import BulletTickList from '~/components/atoms/BulletTickList/BulletTickList'
import Button, { ButtonTypes } from '~/components/atoms/Button/Button'
import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import SpecificImage from '~/components/atoms/SpecificImage/SpecificImage'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './PremiumContentBanner.module.css'

interface PremiumContentBannerProps {
  buttonText: string
  clickHandler: (e: React.MouseEvent) => void
  componentText: {
    title: string
    text: string
    bullets: string[]
  }
}
export default function PremiumContentBanner({
  buttonText,
  clickHandler,
  componentText,
}: PremiumContentBannerProps) {
  const t = useTranslations('premiumContentBanner')

  type Expert = {
    name: string
    jobRole: string
    image: {
      asset: {
        _ref: string
      }
    }
  }

  const experts: Expert[] = [
    {
      name: 'Jess Bromovsky',
      jobRole: 'Senior Director',
      image: {
        asset: {
          _ref: 'image-614036f79512374424e66536b85496247ff3f43d-1575x1912-png',
        },
      },
    },
    {
      name: 'Louisa Earl',
      jobRole: 'Sales Director',
      image: {
        asset: {
          _ref: 'image-5439a916ca63f86a7dfac2dd57633f31d3b89c03-1575x1912-png',
        },
      },
    },
    {
      name: 'Jasper Tordoff',
      jobRole: 'Specialist',
      image: {
        asset: {
          _ref: 'image-eefc15898bc76e4620f2ee86fe2ac54822633bc6-1575x1912-png',
        },
      },
    },
    {
      name: 'Joey Syer',
      jobRole: 'Co-Founder & Specialist',
      image: {
        asset: {
          _ref: 'image-c0f5a59c7607d660678e65fd57e62a4f668ede30-1574x1912-png',
        },
      },
    },
  ]

  return (
    <div className={styles.base}>
      <Container gutters={gutterTypes.always}>
        <div className={styles.inner}>
          <Text
            size={TextSizes.primaryTitleMed}
            Tag="p"
            className={styles.eyebrow}
          >
            <em>My</em>portfolio
          </Text>

          <Text
            size={TextSizes.magSecondaryTitleLrg}
            Tag="h4"
            className={styles.title}
          >
            {componentText.title}
          </Text>

          <Text size={TextSizes.bodyMed} Tag="p" className={styles.body}>
            {componentText.text}
          </Text>

          <div className={styles.bullets}>
            <BulletTickList items={componentText.bullets} />
          </div>

          <div className={styles.cta}>
            <Button
              button={{
                type: ButtonTypes.button,
                onClick: e => {
                  clickHandler(e)
                },
              }}
              iconLeft
            >
              {' '}
              {buttonText}
            </Button>
          </div>

          <div className={styles.experts}>
            {experts.map(expert => {
              return (
                <div key={expert.name} className={styles.expert}>
                  <div className={styles.avatar}>
                    <SpecificImage
                      alt={expert.name}
                      asset={expert.image}
                      width={240}
                    />
                  </div>
                  <Text
                    Tag="h5"
                    size={TextSizes.bodyMed}
                    className={styles.expertName}
                  >
                    {expert.name}
                  </Text>
                  <Text
                    Tag="p"
                    size={TextSizes.bodyMed}
                    className={styles.expertRole}
                  >
                    {expert.jobRole}
                  </Text>
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </div>
  )
}
